import { Grid } from '@mui/material';

import AuthCarousel from '../../shared/Carousels/AuthCarousel';
import { SignupComponent } from './SignupComponent';

export const Signup = () => {
    return (
        <Grid
            container
            sx={{
                display: { md: 'flex', xs: 'block' },
                width: '100%'
            }}>
            <Grid item md={8} xl={8} sx={{ display: { md: 'block', xs: 'none' } }}>
                <AuthCarousel />
            </Grid>
            <Grid display="flex" justifyContent="center" height="100vh" item xs={12} md={4}>
                <SignupComponent />
            </Grid>
        </Grid>
    );
};
